module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAUNJREFUOBGtUsFRwzAQPMV+kLxSgjtATHhAXqICnAowJVABdMCkg1ABLkF5wSMPdUA6AD7m4yD2bJ/GwYIZJmhGo7td7Uq6E9GBQ/X1WptpMqF7YHmHl7uKbpIx3ZGiK2BN7px9E10qAa8QWzge97AiHVNWf9ACJoVSVKQT0uBPZM9Igtm5yb+JW0qRSY8aUdnt1adnxoguGMCdneNjRAb8NpDIJQ4G3pMTcLB+kgWfBRy5xHtFnM2NGzzD0xo1yFGfF3BTQr55skYMwg0YQMUNTlpivndz2Yi5Cy32wLmI/2UNT+AuoNeXOIkLlrE7brEFhtaqsq78mrvh0UrlabV5tpb3KD03OvH0KCIGY4PNdooW+Dj8hFtMVxNdq2jhYg4t5uqKLvCZXrstbjSo+s9iZnT/G3O+14XftXH2YIO47R/QLywDZZ+TC4GYAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu/ic_friends_menu.png
// module id = 1269
// module chunks = 0